import angular from 'angular';
import textComponent from './text.component';

let textModule = angular.module('text', [])

.component('text', textComponent)

.name;

export default textModule;



// WEBPACK FOOTER //
// ./client/app/components/content-types/text/text.js